import CloseIcon from "@styles/all-images/icons/closeblack.svg";
interface TierRejectionReasonProps {
  onClose: () => void;
  onSubmit: () => void;
}

const TierRejectionReason = ({
  onClose,
  onSubmit,
}: TierRejectionReasonProps) => {
  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/25 tw-flex tw-items-center tw-justify-center tw-z-50">
      <div className="tw-bg-white tw-rounded-lg tw-w-[400px]">
        <div className="tw-flex tw-justify-between tw-items-center tw-px-4 tw-py-4 tw-border-b">
          <div></div>
          <h2 className="tw-text-base tw-font-semibold">Delete Task?</h2>
          <button onClick={onClose}>
            <img src={CloseIcon} alt="Close" className="tw-w-auto tw-h-auto" />
          </button>
        </div>
        <div className="tw-p-4 tw-text-center tw-flex tw-flex-col tw-gap-2 tw-py-5 tw-px-6">
          <h6 className="tw-text-[#232323] tw-text-base tw-font-semibold">
            Are you sure you want to delete?
          </h6>
          <p className="tw-text-[#232323] tw-text-sm tw-font-normal">
            Deleting a task will permanently remove it.
          </p>
        </div>
        <div className="tw-flex tw-space-x-4 tw-py-5 tw-px-12">
          <button
            onClick={onClose}
            className="tw-flex-1 tw-px-4 tw-py-2 tw-border font-default-primary-color tw-border-[#146C94] tw-rounded-lg tw-w-[50%] tw-text-center"
          >
            No
          </button>
          <button
            onClick={onSubmit}
            className="tw-bg-blue-600 hover:tw-bg-blue-700 tw-flex tw-items-center tw-gap-2 tw-w-[50%] tw-justify-center tw-text-white tw-rounded-md tw-px-4 tw-py-2 primary-custom-button"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default TierRejectionReason;
